"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _Head = _interopRequireDefault(require("./Head"));
var _Body = _interopRequireDefault(require("./Body"));
var _excluded = ["className", "fields", "objects", "loading", "progress", "onClick", "onClickItem", "selected", "onSelect", "onSelectAll", "excludeFields", "keys", "actions", "actionsList", "setRef", "selectable", "onCollapse", "collapsable", "toggleable", "onLongPress"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Table/index.js";
var noop = function noop() {};
var defaultProps = {
  fields: {},
  objects: [],
  excludeFields: [],
  keys: [],
  selected: [],
  progress: false,
  loading: false,
  onClick: noop,
  onClickItem: noop,
  onSelect: noop,
  onSelectAll: noop,
  readOnly: false,
  actions: [],
  actionsList: [],
  selectable: false,
  collapsable: false,
  toggleable: false,
  onCollapse: noop,
  onLongPress: noop
};
function Table(_ref) {
  var className = _ref.className,
    fields = _ref.fields,
    objects = _ref.objects,
    loading = _ref.loading,
    progress = _ref.progress,
    onClick = _ref.onClick,
    onClickItem = _ref.onClickItem,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    onSelectAll = _ref.onSelectAll,
    excludeFields = _ref.excludeFields,
    keys = _ref.keys,
    actions = _ref.actions,
    actionsList = _ref.actionsList,
    setRef = _ref.setRef,
    selectable = _ref.selectable,
    onCollapse = _ref.onCollapse,
    collapsable = _ref.collapsable,
    toggleable = _ref.toggleable,
    onLongPress = _ref.onLongPress,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var fieldImage = Object.keys(fields).find(function (field) {
    return fields[field]._type === "Image" && fields[field].read !== false || fields[field].detail;
  });
  loading = loading || progress; // progress is deprecated

  var columns = keys.length > 0 ? keys : Object.keys(fields);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    className: (0, _classNames["default"])("table-responsive shadow-sm", className),
    ref: setRef
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("table", {
    className: "table mb-0 w-100 table-striped",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    className: "table-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement(_Head["default"], {
    fields: fields,
    selectable: selectable,
    columns: columns,
    excludes: excludeFields,
    actionsList: actionsList,
    selected: selected,
    onSelectAll: onSelectAll,
    objects: objects,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "bg-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 21
    }
  }, objects.length === 0 && !loading && /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center fs-lg",
    colSpan: Object.keys(fields).length + 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 33
    }
  }, "No Data Found")), /*#__PURE__*/_react["default"].createElement(_Body["default"], {
    objects: objects,
    fields: fields,
    columns: columns,
    excludes: excludeFields,
    selected: selected,
    selectable: selectable,
    onSelect: onSelect,
    onClick: onClick,
    onLongPress: onLongPress,
    actionsList: actionsList,
    collapsable: collapsable,
    toggleable: toggleable,
    onCollapse: onCollapse,
    actions: actions,
    onClickItem: onClickItem,
    fieldImage: fieldImage,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 21
    }
  }), loading && /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: Object.keys(fields).length + 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    className: "fs-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 33
    }
  }, "Loading ...")))))));
}
Table.defaultProps = defaultProps;
var _default = exports["default"] = Table;